<template>
  <div :class="addClass">
    <div class="form-group">
      <label class="form__label form__label--block">{{ getTranslation(formLabel) }} <span v-if="required" class="required">*</span></label>
      <span v-if="description" class="text text-muted">{{ getTranslation(description) }}</span>
      <v-select
          ref="airlineSelect"
          v-model="item_id"
          :options="items"
          :reduce="option=>option.id"
          @search:blur="!item_id ? customValidator.item_id = false : customValidator.item_id = true"
          :class="{ 'is-invalid': !customValidator.item_id && required}"
          :placeholder="getTranslation(placeholder)"
          label="title"
      />
      <div v-if="required && !customValidator.item_id" class="invalid-feedback">{{ getTranslation('requiredField') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AirlineSelect",
  props: {
    editItemId: {
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    description: {
      type: String
    },
    addClass: String,
    formLabel: {
      type: String,
      default: 'airline'
    },
    placeholder: {
      type: String,
      default: 'selectFromList'
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      item_id: '',
      timer: null,
      showSelect: false,
      customValidator: {
        item_id: true,
      },
      params: { count: 50, status: 1 },
      url: this.$urls.application.airlines.url
    }
  },
  watch: {
    'active'(val){
      if ( val )
        this.fetchItems().then(() => {
          if ( this.editItemId )
            this.item_id = this.editItemId;
        })
    },
    'item_id'(id) {

      this.$emit('input', id);

      if ( !id ) {
        this.fetchItems();
      }
    }
  },
  mounted() {
    let searchInput = this.$refs.airlineSelect.$el.getElementsByClassName('vs__search');
    let searchText = '';

    if ( searchInput.length > 0 ) searchInput[0].oninput = e => {
      if ( this.timer ) clearTimeout(this.timer);
      if ( searchText !== e.target.value ) {
        this.timer = setTimeout(() => {
          searchText = e.target.value;
          this.searchItem(searchText);
          this.timer = null;
        }, 500);
      }
    };
  },


  created() {
    this.fetchItems().then(() => {
      if ( this.editItemId )
        this.item_id = this.editItemId;
    })
  },
  methods: {

    fetchItems() {

      if ( this.editItemId )
        this.params.id = this.editItemId;

      return this.axios.get(this.url, { params: this.params }).then(response => {
        this.items = response.data.data.items;
      }).catch(() => {
      });
    },

    searchItem(query) {

      if ( query ) this.params.query = query;

      return this.axios.get(this.url, { params: this.params })
          .then(response => {
            this.items = response.data.data.items;
          }).catch(() => {
          });
    },

    // We will call this method from parent component for check validity
    checkValidity() {
      if ( !this.item_id ) {
        this.customValidator.item_id = false;
        return false;
      }

      return true;
    }
  }
}
</script>

<style scoped>

</style>